import { Star, ThumbsUp, Calendar, User } from "lucide-react";
import { StarRating } from "./StarRating";

export default function ReviewCard({ review }) {
  const {
    user_name,
    rating,
    title,
    content,
    created_at,
  } = review;

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <div 
      className="rounded-xl bg-card border border-white/5 p-5 card-hover"
      data-testid={`review-card-${review.id}`}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-purple-600 flex items-center justify-center text-white font-bold">
            {user_name.charAt(0).toUpperCase()}
          </div>
          <div>
            <h4 className="text-white font-medium">{user_name}</h4>
            <div className="flex items-center gap-2 text-white/40 text-xs">
              <Calendar className="w-3 h-3" />
              <span>{formatDate(created_at)}</span>
            </div>
          </div>
        </div>
        <StarRating rating={rating} size="sm" />
      </div>

      {/* Content */}
      <h5 className="text-white font-semibold mb-2">{title}</h5>
      <p className="text-white/60 text-sm line-clamp-3">{content}</p>

      {/* Actions */}
      <div className="flex items-center gap-4 mt-4 pt-4 border-t border-white/5">
        <button className="flex items-center gap-1 text-white/40 text-sm hover:text-primary transition-colors">
          <ThumbsUp className="w-4 h-4" />
          <span>Helpful</span>
        </button>
      </div>
    </div>
  );
}
